import { SegmentCheckoutTypeEnum } from "../../enum/segment/segment-checkout-type.enum";
import { SegmentOrderSideEnum } from "../../enum/segment/segment-order-side.enum";
import { SegmentMarketTypeEnum } from "../../enum/segment/segment-market-type.enum";

export class OrderSentEvent {
    constructor(
        public type: string,
        public ticker: string,
        public origin: string,
        public direction: SegmentOrderSideEnum,
        public productType: SegmentMarketTypeEnum,
        public quantity: number,
        public cblc: number,
        public suitability: string,
        public isDayTrade: boolean,
        public checkoutVersion: string,
        public category?: string,
        public price?: string,
        public gainValue?: string,
        public lossValue?: string,
        public dueDate?: string,
        public isFractionary?: boolean,
        public isToroApp?: boolean,
        public suitabilityBypass?: boolean,
        public guaranteeValueUsed?: string
    ) { }
}
